export const IncomeI18n = {
  zh: {
    "metaTitle":"收益宝",
    "metaDescription":"收益宝通过精选交易对和策略，在严格控制投资风险的前提下，为用户获取超越同类产品的稳健收益",
    "income-title": "收益宝产品购买流程",
    "income-step-1": "第一步：选择产品",
    "income-des-1": "点击我的账户下的账户 ---->  点击收益宝 ----> 选择任意理财产品",
    "income-step-2": "第二步：进入Veta界面并连接钱包",
    "income-des-2": "点击任意理财产品  ------->   确认连接钱包",
    "income-step-3": "第三步：输入认购数量",
    "income-des-3": "确认产品规格 ---> 输入认购数量",
    "income-step-4": "第四步：发起授权交易",
    "income-des-4.1":
      "（首次交易需要先进行一次授权，后续不超过授权额度则无需再授权，可直接跳至第六步）下滑点击授权  ---> 输入授权金额（需大于等于认购数量） ---->  签名确认",
    "income-des-4.2": "等待dapp唤起钱包交易授权按钮  --->  点击确认--->  输入支付密码",
    "income-step-5": "第五步：等待授权交易完成",
    "income-des-5":
      "等待区块确认 ---> 区块确认完成后，钱包弹出交易结果页面--->  授权变为确认。（若授权状态长时间未更新，可刷新界面）",
    "income-step-6": "第六步：购买产品",
    "income-des-6.1": "点击确认-->  等待唤起钱包签名-->  点击交易确认",
    "income-des-6.2": "输入账户密码 --> 等待交易  --> 钱包唤起交易结果",
    "income-step-7": "第七步：查看持仓情况",
    "income-des-7.1": "交易成功 --> 跳转到持仓页，查看认购信息",
    "income-des-7.2": "或者返回到收益宝页面 --> 点击持仓查看认购详情。",
  },
  en: {
    "metaTitle":"Yied",
    "metaDescription":"CryptoGain selects trading pairs and strategies rigorously to achieve stable returns surpassing similar products while strictly controlling investment risks for users.",
    "income-title": "CryptoGain product purchase process",
    "income-step-1": "Step1:Select product",
    "income-des-1": "Click Account —> CryptoGain —> Choose any financial product",
    "income-step-2": "Step2:Enter the Veta interface and connect the wallet",
    "income-des-2": "Click on any financial product —> Confirm to connect the wallet",
    "income-step-3": "Step3:Enter the subscription quantity",
    "income-des-3": "Confirm product specification —> Enter subscription quantity",
    "income-step-4": "Step4:Send authorization transaction",
    "income-des-4.1":
      "(The first transaction needs to be authorized once, and subsequent authorization is not required if the authorized amount does not exceed, you can directly skip to step 6)Slide down and click Authorization —> Enter the authorization amount (must be greater than or equal to the subscription amount) —> Signature confirmation",
    "income-des-4.2":
      "Wait for the dapp to evoke the wallet transaction authorization button —> click Confirm —>enter the payment password",
    "income-step-5": "Step5:Wait for the authorization transaction to complete",
    "income-des-5":
      "Waiting for block confirmation —> After the block confirmation is completed, the wallet pops up the transaction result page —> Authorization changes to confirmation.(If the authorization status has not been updated for a long time, you can refresh the interface)",
    "income-step-6": "Step6:Buy  product",
    "income-des-6.1":
      "Click Confirm —> Wait for the wallet signature to be evoked —> Click Transaction Confirmatio",
    "income-des-6.2":
      "Enter the account password —> wait for the transaction —> the wallet invokes the transaction result",
    "income-step-7": "Step7:View position status",
    "income-des-7.1":
      "Transaction successful —> Jump to the position page to view subscription information",
    "income-des-7.2":
      "Or return to the CryptoGain page —> click on the position to view the subscription details.",
  },
};
